<div class="foreground" >
  <div class="back cursor" [ngClass]="dynamicClass" (click)="btnClicked($event)" (mouseenter)="changeUrl(arrowhoverUrl)" (mouseleave)="changeUrl(arrowUrl)">
    <app-image [src]="url"></app-image>
  </div>
</div>
